import { Autocomplete, TextField } from '@mui/material';
import customAxios from '../../../utils/customAxios';
import { useEffect, useState } from 'react';
import Modal from 'react-bootstrap/Modal';
import { toast } from 'react-toastify';
import "../../../scss/Components/_modal.scss"
import { useTranslationHook } from '../../../hooks/UseTranslationHook';
import { GlobalVariables } from '../../../globalVar';
import { getToast } from '../../../utils/toastConfig';

function ModalR(props) {
    const {
        rModalCreateString,
        rModalCreateQNameString,
        rModalCreateQDescString,
        saveString,
    } = useTranslationHook();

    const [newOption, setNewOption] = useState({ name: '', description: '' })

    function createQ(event) {
        event.preventDefault();
        customAxios.post(`${GlobalVariables.getURL()}createReport`, {
            name: newOption.name,
            description: newOption.description,
            questionnaireId: props.questionnaireId
        }, {
            headers: {
                'Authorization': 'bearer ' + localStorage.getItem('token')
            }
        })
            .then((response) => {
                hide();
            }, (error) => {
                console.log(error);
                getToast({ status: 'error', title: 'Error al crear reporte. Vuelve a intentarlo.' });
            });
    }


    function hide() {
        props.onHide();
        getToast({ status: 'success', title: 'Reporte creado exitosamente en la base de datos.' });
        props.getReports();
    }

    return (
        <Modal
            {...props}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
        >
            <Modal.Header closeButton>
                <Modal.Title id="contained-modal-title-vcenter">
                    {rModalCreateString}
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <form id='add-r-form' onSubmit={createQ}>
                    <div className="row">
                        <div className="col-md-12">
                            <TextField
                                sx={{ width: "100%" }}
                                label={rModalCreateQNameString}
                                type="text"
                                onChange={(e) => setNewOption({ ...newOption, name: e.target.value })}
                                required
                            />
                        </div>
                    </div>

                    <br />

                    <div className="row">
                        <div className="col-md-12">
                            <TextField
                                multiline
                                sx={{ width: "100%" }}
                                label={rModalCreateQDescString}
                                rows={4}
                                type="text"
                                onChange={(e) => setNewOption({ ...newOption, description: e.target.value })}
                            />
                        </div>
                    </div>
                </form>
            </Modal.Body>
            <Modal.Footer>
                <button form='add-r-form' type='submit' className='save-modal-button'>{saveString}</button>
            </Modal.Footer>
        </Modal>
    );
};

export default ModalR;